module.exports = __webpack_public_path__ + "static/media/highQuality.a0e146a3.svg";